import { i18n } from "translations";
import { getMapObjectFromArray } from "utils";

import { EmployeePersonalContactAddressType } from "./types";

export const EmployeePersonalContactAddressTypeOptions = [
  {
    label: i18n.t("permanent"),
    value: EmployeePersonalContactAddressType.Permanent,
  },
  {
    label: i18n.t("temporary"),
    value: EmployeePersonalContactAddressType.Temporary,
  },
];

export const EmployeePersonalContactAddressTypeMap = getMapObjectFromArray(
  EmployeePersonalContactAddressTypeOptions
);
